import { render } from "./CollectionDetailsContainer.vue?vue&type=template&id=c9bc2970&scoped=true"
import script from "./CollectionDetailsContainer.vue?vue&type=script&lang=js"
export * from "./CollectionDetailsContainer.vue?vue&type=script&lang=js"

import "./CollectionDetailsContainer.vue?vue&type=style&index=0&id=c9bc2970&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9bc2970"]])

export default __exports__